export default function getBusinessImage(id: number, imgType?: string): string {
  const cdnUrl = import.meta.env.VITE_CDN_URL || "https://cdn.region.game/";
  const serverName = import.meta.env.VITE_SERVER_NAME || "ivanovo";
  const img = imgType || "large";
  return [cdnUrl, "server/", serverName, "/business/", id, `/${img}.jpg`].join("");
}

export function getBusinessCardImage(id: number, type: string): string {
  const cdnUrl = import.meta.env.VITE_CDN_URL || "https://cdn.region.game/";
  const serverName = import.meta.env.VITE_SERVER_NAME || "ivanovo";
  return [cdnUrl, "server/", serverName, "/business/", type, `/${id}.webp`].join("");
}
